module.exports = {"data":{"page":{"id":"/opt/build/repo/content/pages/success/index.md absPath of file >>> MarkdownRemark","html":"<p>Thank you. <br />\nI will answer to your message as soon as possible.</p>","frontmatter":{"title":"Success"}},"site":{"siteMetadata":{"facebook":{"appId":"1184472234930745"}}}},"pathContext":{"slug":"/success/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/success.json
// module id = 874
// module chunks = 170786371021445